import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import useIsSearchingOrFiltering from '../../hooks/useIsSearchingOrFiltering';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/components/View';
import useCrmObjectTypeListingFilters from 'framework-listing-lib/hooks/useCrmObjectTypeListingFilters';
import { trackDashboardInteraction } from 'EmailData/utils/tracking';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FoldersViewEmptyState() {
  const isSearchingOrFiltering = useIsSearchingOrFiltering({
    isFoldersMode: true
  });
  const {
    onClearFilters
  } = useCrmObjectTypeListingFilters();
  const clearFilters = useCallback(() => {
    onClearFilters();
    trackDashboardInteraction({
      otherActions: 'framework-empty-state-clear-filter'
    });
  }, [onClearFilters]);
  if (isSearchingOrFiltering) {
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "center",
      blockSize: "400px",
      paddingInline: "300",
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "200",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h4",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management.foldersViewEmptyState.noMatchingEmails.title"
          })
        }), /*#__PURE__*/_jsx(Text, {
          as: "p",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management.foldersViewEmptyState.noMatchingEmails.description"
          })
        }), /*#__PURE__*/_jsx(View, {
          children: /*#__PURE__*/_jsx(Button, {
            onClick: clearFilters,
            use: "link",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "email-management.foldersViewEmptyState.noMatchingEmails.resetButtonText"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Illustration, {
        name: "empty-state-charts",
        marginInlineStart: "800"
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "center",
    blockSize: "400px",
    paddingInline: "300",
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "200",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.foldersViewEmptyState.emptyFolder.title"
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "p",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.foldersViewEmptyState.emptyFolder.description"
        })
      })]
    }), /*#__PURE__*/_jsx(Illustration, {
      name: "email-empty-state-high-performing",
      marginInlineStart: "800"
    })]
  });
}